import React, { useState } from 'react'; // Import useState
import { Button, Card, CardBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterType } from '../../rtk/slices/filterSlice/filterSlice'; // Adjust the path as necessary

const FilterSidebar = ({ isOpen, toggleSidebar }) => {
    const dispatch = useDispatch();
    const filterDate = ['All','Today', 'Last Week', 'Last Month', 'Last 3 Months', 'Last 6 Months', 'Last Year', 'Custom'];

    // Local state to keep track of the active filter
    const [activeFilter, setActiveFilter] = useState('All');

    const savedLayoutMode = localStorage.getItem('layoutMode') 
    

    const handleFilterChange = (filter) => {
        dispatch(setFilterType(filter)); // Dispatch the action to update the filter type
        setActiveFilter(filter); // Update active filter state
        toggleSidebar(); // Close the sidebar after applying the filter
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                width: '300px',
                height: '100vh',
                backgroundColor: savedLayoutMode ==='light' ? '#F3F2F8':'#212529',
                boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.5)',
                transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
                transition: 'transform 0.3s ease-in-out',
                zIndex: '9999'
            }}
        >
            <Card className="fw shadow-none bg-transparent">
                <div className="d-flex p-1 mb-2">
                    <div className="col" style={{ flexGrow: '0.75' }}>
                        <Button color='danger' style={{ width: 'fit-content', padding: "0px 4px" }}
                            onClick={toggleSidebar}
                        >
                            <i className="ri-close-line"></i>
                        </Button>
                    </div>
                    <div className="col">
                        <h5 className="mb-0">History</h5>
                    </div>
                </div>

                <CardBody className='p-0'>
                    <div className="d-flex align-items-center justify-content-between p-1 mb-2">
                        <h5 className='mb-0 fs-6'>Filter By:</h5>
                    </div>
                    <ul  style={{ listStyleType: 'none', padding: "5px" }}>
                        {filterDate.map(filter => (
                            <li className='mb-1' style={{ borderRadius: "5px" }} key={filter}>
                                <Button
                                    // color={activeFilter === filter ? "danger" : "link"} // Change button color based on active filter
                                    className={`d-block w-100 fw-bold text-white border-0`} // Change text color
                                    style={{
                                        textAlign: "left",
                                        backgroundColor: activeFilter === filter ? "#3577f1" : "rgb(53 119 241 / 50%)", // Set background color for active filter
                                    }}
                                    onClick={() => handleFilterChange(filter)}
                                >
                                    {filter}
                                </Button>
                            </li>
                        ))}
                    </ul>
                </CardBody>
            </Card>
        </div>
    );
};

export default FilterSidebar;
